import React from 'react';

import { token, useThemeObserver } from '@atlaskit/tokens';

export const EmptyStateIcon: React.FC = () => {
	const theme = useThemeObserver() as string;
	const strokeOpacity = theme === 'dark' ? 0.08 : 0.06;

	const outlineColor = token('color.background.accent.gray.subtler.hovered', '#091E42');
	const rectangleFillColor = token('color.background.input.pressed', 'white');

	return (
		<svg
			width="192"
			height="115"
			viewBox="0 0 192 115"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M62 69H104.955C109.374 69 112.955 72.5817 112.955 77V95"
				stroke={outlineColor}
				strokeOpacity={strokeOpacity}
				strokeWidth="2"
			/>
			<mask id="path-2-inside-1_1463_141307" fill="white">
				<path d="M121 103C121 107.418 117.418 111 113 111C108.582 111 105 107.418 105 103C105 98.5817 108.582 95 113 95C117.418 95 121 98.5817 121 103ZM113 96.7778C109.564 96.7778 106.778 99.5636 106.778 103C106.778 106.436 109.564 109.222 113 109.222C116.436 109.222 119.222 106.436 119.222 103C119.222 99.5636 116.436 96.7778 113 96.7778ZM113.882 100.374L113.889 100.486L113.889 102.111L115.514 102.111C116.005 102.111 116.403 102.509 116.403 103C116.403 103.453 116.064 103.827 115.626 103.882L115.514 103.889L113.889 103.889L113.889 105.514C113.889 106.005 113.491 106.403 113 106.403C112.547 106.403 112.173 106.064 112.118 105.626L112.111 105.514L112.111 103.889L110.486 103.889C109.995 103.889 109.597 103.491 109.597 103C109.597 102.547 109.936 102.173 110.374 102.118L110.486 102.111L112.111 102.111L112.111 100.486C112.111 99.9949 112.509 99.597 113 99.597C113.453 99.597 113.827 99.9361 113.882 100.374Z" />
			</mask>
			<path
				d="M121 103H119H121ZM113 111V109V111ZM105 103H107H105ZM113.882 100.374L115.878 100.25L115.874 100.188L115.866 100.126L113.882 100.374ZM113.889 100.486L115.889 100.485L115.889 100.423L115.885 100.362L113.889 100.486ZM113.889 102.111L111.889 102.111L111.89 104.11L113.889 104.111L113.889 102.111ZM115.514 102.111L115.514 104.111H115.514V102.111ZM116.403 103H118.403H116.403ZM115.626 103.882L115.75 105.878L115.812 105.874L115.874 105.866L115.626 103.882ZM115.514 103.889L115.515 105.889L115.577 105.889L115.638 105.885L115.514 103.889ZM113.889 103.889L113.889 101.889L111.89 101.89L111.889 103.889L113.889 103.889ZM113.889 105.514L111.889 105.514V105.514H113.889ZM113 106.403V108.403V106.403ZM112.118 105.626L110.122 105.75L110.126 105.812L110.134 105.874L112.118 105.626ZM112.111 105.514L110.111 105.515L110.111 105.577L110.115 105.638L112.111 105.514ZM112.111 103.889L114.111 103.889L114.11 101.89L112.111 101.889L112.111 103.889ZM110.486 103.889L110.486 101.889H110.486V103.889ZM109.597 103H107.597H109.597ZM110.374 102.118L110.25 100.122L110.188 100.126L110.126 100.134L110.374 102.118ZM110.486 102.111L110.485 100.111L110.423 100.111L110.362 100.115L110.486 102.111ZM112.111 102.111L112.111 104.111L114.11 104.11L114.111 102.111L112.111 102.111ZM112.111 100.486L114.111 100.486V100.486H112.111ZM119 103C119 106.314 116.314 109 113 109V113C118.523 113 123 108.523 123 103H119ZM113 109C109.686 109 107 106.314 107 103H103C103 108.523 107.477 113 113 113V109ZM107 103C107 99.6863 109.686 97 113 97V93C107.477 93 103 97.4772 103 103H107ZM113 97C116.314 97 119 99.6863 119 103H123C123 97.4772 118.523 93 113 93V97ZM113 94.7778C108.459 94.7778 104.778 98.459 104.778 103H108.778C108.778 100.668 110.668 98.7778 113 98.7778V94.7778ZM104.778 103C104.778 107.541 108.459 111.222 113 111.222V107.222C110.668 107.222 108.778 105.332 108.778 103H104.778ZM113 111.222C117.541 111.222 121.222 107.541 121.222 103H117.222C117.222 105.332 115.332 107.222 113 107.222V111.222ZM121.222 103C121.222 98.459 117.541 94.7778 113 94.7778V98.7778C115.332 98.7778 117.222 100.668 117.222 103H121.222ZM111.886 100.498L111.893 100.61L115.885 100.362L115.878 100.25L111.886 100.498ZM111.889 100.486L111.889 102.111L115.889 102.11L115.889 100.485L111.889 100.486ZM113.889 104.111L115.514 104.111L115.515 100.111L113.89 100.111L113.889 104.111ZM115.514 104.111C114.901 104.111 114.403 103.614 114.403 103H118.403C118.403 101.405 117.11 100.111 115.514 100.111V104.111ZM114.403 103C114.403 102.432 114.827 101.966 115.377 101.897L115.874 105.866C117.3 105.688 118.403 104.474 118.403 103H114.403ZM115.502 101.886L115.39 101.893L115.638 105.885L115.75 105.878L115.502 101.886ZM115.514 101.889L113.889 101.889L113.89 105.889L115.515 105.889L115.514 101.889ZM111.889 103.889L111.889 105.514L115.889 105.515L115.889 103.89L111.889 103.889ZM111.889 105.514C111.889 104.901 112.386 104.403 113 104.403V108.403C114.595 108.403 115.889 107.11 115.889 105.514H111.889ZM113 104.403C113.568 104.403 114.034 104.827 114.103 105.377L110.134 105.874C110.312 107.3 111.526 108.403 113 108.403V104.403ZM114.114 105.502L114.107 105.39L110.115 105.638L110.122 105.75L114.114 105.502ZM114.111 105.514L114.111 103.889L110.111 103.89L110.111 105.515L114.111 105.514ZM112.111 101.889L110.486 101.889L110.485 105.889L112.11 105.889L112.111 101.889ZM110.486 101.889C111.099 101.889 111.597 102.386 111.597 103H107.597C107.597 104.595 108.89 105.889 110.486 105.889V101.889ZM111.597 103C111.597 103.568 111.173 104.034 110.623 104.103L110.126 100.134C108.7 100.312 107.597 101.526 107.597 103H111.597ZM110.498 104.114L110.61 104.107L110.362 100.115L110.25 100.122L110.498 104.114ZM110.486 104.111L112.111 104.111L112.11 100.111L110.485 100.111L110.486 104.111ZM114.111 102.111L114.111 100.486L110.111 100.485L110.111 102.11L114.111 102.111ZM114.111 100.486C114.111 101.099 113.614 101.597 113 101.597V97.597C111.405 97.597 110.111 98.8904 110.111 100.486H114.111ZM113 101.597C112.432 101.597 111.966 101.173 111.897 100.623L115.866 100.126C115.688 98.6995 114.474 97.597 113 97.597V101.597Z"
				fill={outlineColor}
				fillOpacity={strokeOpacity}
				mask="url(#path-2-inside-1_1463_141307)"
			/>
			<path
				d="M32 18.353H74.9553C79.3736 18.353 82.9553 21.9348 82.9553 26.353V42.8236"
				stroke={outlineColor}
				strokeOpacity={strokeOpacity}
				strokeWidth="2"
			/>
			<path
				d="M45 48H87.9553C92.3736 48 95.9553 51.5817 95.9553 56V72.4706"
				stroke={outlineColor}
				strokeOpacity={strokeOpacity}
				strokeWidth="2"
			/>
			<rect x="6" y="4" width="128" height="24" rx="4" fill={rectangleFillColor} />
			<rect
				x="6.5"
				y="4.5"
				width="127"
				height="23"
				rx="3.5"
				stroke={outlineColor}
				strokeOpacity={strokeOpacity}
			/>
			<rect
				x="10"
				y="8"
				width="16"
				height="16"
				rx="2"
				fill={token('color.background.accent.green.subtlest', '#DFFCF0')}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.4863 19.3434C15.8495 19.7176 15.333 19.4234 15.333 18.6847V13.3171C15.333 12.578 15.8477 12.2825 16.4863 12.6576L21.4121 15.5509C21.8348 15.7994 21.8379 16.1998 21.4121 16.45L16.4863 19.3434Z"
				fill={(token('color.background.accent.green.bolder'), '#22A06B')}
			/>
			<rect
				x="34"
				y="11.5"
				width="96"
				height="9"
				rx="2"
				fill={outlineColor}
				fillOpacity={strokeOpacity}
			/>
			<rect x="28" y="33" width="128" height="24" rx="4" fill={rectangleFillColor} />
			<rect
				x="28.5"
				y="33.5"
				width="127"
				height="23"
				rx="3.5"
				stroke={outlineColor}
				strokeOpacity={strokeOpacity}
			/>
			<rect
				x="32"
				y="37"
				width="16"
				height="16"
				rx="2"
				fill={token('color.background.accent.yellow.subtlest', '#FFF7D6')}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M37.778 45.4444H42.2225L42.6669 44.5555H37.3336L37.778 45.4444ZM36.4416 42.3333C36.198 42.3333 36.0905 42.5133 36.1989 42.731L36.4447 43.2221H43.5558L43.8016 42.731C43.9114 42.511 43.8025 42.3333 43.5589 42.3333H36.4416ZM39.4572 47.4693C39.4896 47.5271 39.5363 47.5756 39.5929 47.6102C39.6495 47.6447 39.714 47.6642 39.7803 47.6666H40.2203C40.3443 47.6666 40.4892 47.5777 40.5434 47.4693L40.8892 46.7777H39.1114L39.4572 47.4693Z"
				fill={token('color.icon.accent.orange', '#E56910')}
			/>
			<rect
				x="56"
				y="40.5"
				width="96"
				height="9"
				rx="2"
				fill={outlineColor}
				fillOpacity={strokeOpacity}
			/>
			<rect x="45" y="62" width="128" height="24" rx="4" fill={rectangleFillColor} />
			<rect
				x="45.5"
				y="62.5"
				width="127"
				height="23"
				rx="3.5"
				stroke={outlineColor}
				strokeOpacity={strokeOpacity}
			/>
			<rect
				x="49"
				y="66"
				width="16"
				height="16"
				rx="2"
				fill={token('color.background.accent.blue.subtlest', '#E9F2FF')}
			/>
			<path
				d="M57.8886 70.8889L56.1108 77.1111"
				stroke={token('color.icon.accent.blue', '#1D7AFC')}
				strokeLinecap="round"
			/>
			<path
				d="M57.8889 70.8889L54.7778 74H59.2223L56.1112 77.1111"
				stroke={token('color.icon.accent.blue', '#1D7AFC')}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="73"
				y="69.5"
				width="96"
				height="9"
				rx="2"
				fill={outlineColor}
				fillOpacity={strokeOpacity}
			/>
		</svg>
	);
};
